/**
 * Compose parse → derive → freeze. Exports UNIVERSE and UNIVERSE_SIZE (plan §3.3).
 * Never hard-code a universe count in product code — use UNIVERSE_SIZE.
 */
import { deriveSecurity, type DerivedSecurity } from './derive-security';
import { parseUniverse } from './parse-universe';

function build(): readonly DerivedSecurity[] {
  const rows = parseUniverse();
  const list = rows.map((row) => deriveSecurity(row));
  return Object.freeze(list);
}

/** Frozen synthetic universe (demo-fidelity profile). */
export const UNIVERSE: readonly DerivedSecurity[] = build();

/** Count of securities in UNIVERSE — the only sanctioned size symbol. */
export const UNIVERSE_SIZE: number = UNIVERSE.length;
